// export const prevArrow = `
//     <button class="slider__arrow slider__prev slick-prev button">
//         <svg class="icon icon--prev" xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45" style="transform:rotate(90deg)">
//             <path d="M31.946 17.778 22.5 27.225l-9.446-9.447" fill="none" stroke="currentColor" stroke-width="6"/>
//         </svg>
//     </button>`;
// export const nextArrow = `
//     <button class="slider__arrow slider__next slick-next button">
//         <svg class="icon icon--next" xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45" style="transform:rotate(-90deg)">
//             <path d="M31.946 17.778 22.5 27.225l-9.446-9.447" fill="none" stroke="currentColor" stroke-width="6"/>
//         </svg>
//     </button>`;

export const prevArrow = `<svg class="slider__arrow slider__prev slick-prev button" xmlns="http://www.w3.org/2000/svg" width="18.459" height="31.262" viewBox="0 0 18.459 31.262"><g id="Group_157" data-name="Group 157" transform="translate(879.329 -154.325) rotate(90)"><path id="Path_51" data-name="Path 51" d="M985.283,1001.984,999.5,1016.2l14.217-14.217" transform="translate(-829.544 -139.701)" fill="none" stroke="#e73929" stroke-width="4"/></g></svg>`;
export const nextArrow = `<svg class="slider__arrow slider__next slick-next button" xmlns="http://www.w3.org/2000/svg" width="18.459" height="31.262" viewBox="0 0 18.459 31.262"><g id="Group_157" data-name="Group 157" transform="translate(-860.869 185.586) rotate(-90)"><path id="Path_51" data-name="Path 51" d="M985.283,1001.984,999.5,1016.2l14.217-14.217" transform="translate(-829.544 -139.701)" fill="none" stroke="#e73929" stroke-width="4"/></g></svg>`;

export const options = {
    slidesToShow: 3,
    swipeToSlide: true,
    infinite: false,
    cssEase: 'ease',
    speed: 300,
    nextArrow,
    prevArrow
};

